module.exports = __webpack_public_path__ + "img/banner2.a99e6b96.jpg";